import { createMuiTheme } from '@material-ui/core/styles';
var actionBarTheme = createMuiTheme({
  palette: {
    primary: {
      light: '#4f6182',
      main: '#334058',
      dark: '#1a2a47',
      contrastText: '#fff'
    },
    secondary: {
      light: '#00BFA5',
      main: '#00BFA5',
      dark: '#00BFA5',
      contrastText: '#fff'
    }
  },
  typography: {
    useNextVariants: true
  }
});
export default actionBarTheme;